// extracted by mini-css-extract-plugin
module.exports = {"layout":"large-modal-window_layout__Ci9Tu","fadeIn":"large-modal-window_fadeIn__OWe3Z","container":"large-modal-window_container__G0lrz","slide":"large-modal-window_slide__oiQ0F"};